export const LINK_TOOLTIP_NAME = 'link-tooltip';
